import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 4v21.5h22" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "m12.5 7.5-3.5 6h3.5L11 19l4.5-7H12zM20 10.5l-3 5.2a3.5 3.5 0 1 0 6 0z" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }